import React, { memo, useCallback } from 'react';
import { NavigateAction } from 'react-big-calendar';
import Navigation from './Navigation';
import { ToolbarContainer, Label } from './ToolbarUI';

interface IProps {
  label: string;
  onNavigate: (action: NavigateAction) => void;
}

export default memo(function Toolbar({ label, onNavigate }: IProps) {
  const navigateToPrevious = useCallback(() => {
    onNavigate('PREV');
  }, [onNavigate]);

  const navigateToNext = useCallback(() => {
    onNavigate('NEXT');
  }, [onNavigate]);

  const navigateToToday = useCallback(() => {
    onNavigate('TODAY');
  }, [onNavigate]);

  return (
    <ToolbarContainer>
      <Label>{label}</Label>

      <Navigation
        navigateToPrevious={navigateToPrevious}
        navigateToNext={navigateToNext}
        navigateToToday={navigateToToday}
      />
    </ToolbarContainer>
  );
});
